module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAMAAACeyVWkAAAAQlBMVEUAAABBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNDt8POsyeZIjNHm7PLR3+2Art1dmda0zueK+wy6AAAADXRSTlMA8Y0kTMy3rjMw5chRvQS2QgAAAIlJREFUGNN1kVsOhDAIRYFara1QX7P/rY5aGKNhztfNSXMbABojlcy50Ag3YWBjCCY75BvsVPKTSwd8WTxLen7TAyTL82e2mIAsVqkWCYqmTUQ2zRFyC/ty2GXX/0BLVzlZtRpQSxtV30ZWDse/XnIsQXJscmfz9+Dv7GJ67Hf6fwu7W0TGaHf7ArUxEUvM09A6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_up2_hover.png
// module id = 0+3s
// module chunks = 9